import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { SIGNED_OUT_PATH, signOut } from './session';

/**
 * Ends the session on the server, then leaves the app — through the identity
 * provider's logout when it offers one (ADR-014). Signing out is not a
 * dangerous action (nothing outside CedarReachAI changes), so it needs no
 * confirmation.
 */
export function SignOutButton() {
  const { t } = useTranslation();
  const [state, setState] = useState<'idle' | 'busy' | 'failed'>('idle');
  return (
    <>
      <Button
        variant="ghost"
        size="sm"
        data-testid="sign-out"
        disabled={state === 'busy'}
        onClick={async () => {
          setState('busy');
          try {
            // Through the provider's logout when it has one; it comes back
            // to the signed-out page.
            const providerLogout = await signOut();
            window.location.assign(providerLogout ?? SIGNED_OUT_PATH);
          } catch {
            setState('failed');
          }
        }}
      >
        <LogOut aria-hidden="true" />
        <span>{state === 'busy' ? t('auth.signingOut') : t('auth.signOut')}</span>
      </Button>
      {state === 'failed' ? (
        <p role="alert" className="text-xs text-destructive">
          {t('auth.signOutFailed')}
        </p>
      ) : null}
    </>
  );
}
